import React from "react";
import TeamMember from "../TeamMember/TeamMember.tsx";
import {ITeamMember, membersItems} from "../../mocks/teamMembersItems.tsx";


const Team: React.FC = () => (
  <div className="h-[600px] max-h-[600px] overflow-hidden">
    <div className="flex items-center mb-4">
      <div className="mr-auto h4">Members</div>
      <button className="btn-purple">Invite</button>
    </div>
    <div className="py-3 base2 text-n-400">{membersItems.length} members</div>
    <div className="h-[500px] max-h-[500px] overflow-auto">
      {membersItems.map((member: ITeamMember, index: number) => (
        <TeamMember
          item={member}
          key={member.id}
          style={{zIndex: membersItems.length - index}}
        />
      ))}
    </div>
  </div>
);

export default Team;
